<template>
    <Tables
        ref="tableGrid"
        :columns="['NOME', 'GRUPO ECONÔMICO', 'CÓD. GRUPO ECONÔMICO']"
        :showHeader="false"
        :showTipFooter="false"
        v-on:Load="onLoadEconomicGroup(objSelected.document)"
    >
        <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.nomeCliente"/>
        <TableColumn :IsText="true" :status="1" :value="obj.descricaoGrupoEconomico" />
        <TableColumn :IsText="true" :status="1" :value="obj.codigoGrupoEconomico.toString()" />
        </tr>
    </Tables>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import EconomicGroupRepository from '@/shared/http/repositories/business/economicgroup.js'
export default {
  name: 'PessoasGrupoEconomico',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadPessoasEconomicGroup(this.document)
      }
    },
    onLoadPessoasEconomicGroup (document) {
      loading.push()
      this.document = document
      EconomicGroupRepository.SearchPeopleIn(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/pessoasgrupoeconomico.vue